import ProjectItemAdmin from './ProjectItemAdmin';

export default ProjectItemAdmin;
